// Функция для обработки входящих значений даты
export const processDateValue = (dateValue) => {
	let dateObj
	let dateString = dateValue

	if (typeof dateValue === 'string') {
		// Парсим строку формата dd.MM.yyyy
		const parts = dateValue.split('.')
		if (parts.length === 3) {
			dateObj = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
		}
	} else if (dateValue instanceof Date) {
		dateObj = dateValue
		// Преобразуем Date в строку для DatePicker
		const day = String(dateValue.getDate()).padStart(2, '0')
		const month = String(dateValue.getMonth() + 1).padStart(2, '0')
		const year = dateValue.getFullYear()
		dateString = `${day}.${month}.${year}`
	}

	if (!dateObj || isNaN(dateObj.getTime())) {
		return { isValid: false }
	}

	return { isValid: true, dateObj, dateString }
}

// Функция для извлечения дат из workLogContent
export const extractDatesFromWorkLogContent = (workLogContent, activeOrgBin) => {
	const uniqueDates = new Set()
	const dates = []

	if (activeOrgBin && workLogContent && Array.isArray(workLogContent) && workLogContent.length > 0) {
		const selectedOrg = workLogContent.find((org) => org.bin === activeOrgBin)

		if (selectedOrg?.employees?.length > 0) {
			const firstEmployee = selectedOrg.employees[0]

			if (firstEmployee?.depts?.length > 0) {
				firstEmployee.depts.forEach((dept) => {
					if (dept?.works?.length > 0) {
						dept.works.forEach((work) => {
							if (work.date) {
								let dateObj
								let dateKey
								if (work.date.includes('.')) {
									const [day, month, year] = work.date.split('.')
									dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 12, 0, 0)
									dateKey = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
								} else {
									dateObj = new Date(work.date + 'T12:00:00')
									dateKey = work.date
								}

								if (!isNaN(dateObj.getTime())) {
									if (!uniqueDates.has(dateKey)) {
										uniqueDates.add(dateKey)
										dates.push(dateObj)
									}
								}
							}
						})
					}
				})
			}
		}
	}

	return dates
}
